import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "quality", spoke: "quality", title: "Quality", icon: VerifiedOutlinedIcon, order: 49, entries: [
  { label: "Dashboard", to: "/app/quality", permission: "quality.inspection.view" },
  { label: "Inspections", to: "/app/quality/inspections", permission: "quality.inspection.view" },
  { label: "Nonconformances", to: "/app/quality/ncrs", permission: "quality.ncr.view" },
  { label: "CAPA", to: "/app/quality/capas", permission: "quality.capa.view" },
  { label: "Customer complaints", to: "/app/quality/complaints", permission: "quality.ncr.view" },
  { label: "Audits", to: "/app/quality/audits", permission: "quality.audit.view" },
  { label: "Gauges & calibration", to: "/app/quality/gauges", permission: "quality.calibration.view" },
  { label: "Documents & reports", to: "/app/quality/reports", permission: "quality.document.view" },
  { label: "Inspection plans", to: "/app/quality/plans", permission: "quality.config.view" },
  { label: "Deviations", to: "/app/masterdata/deviations", permission: "quality.ncr.view" },
  { label: "Quality holds", to: "/app/masterdata/quality-holds", permission: "quality.ncr.view" },
  { label: "Supplier corrective actions", to: "/app/masterdata/scars", permission: "quality.ncr.view" },
  { label: "Supplier qualification", to: "/app/masterdata/supplier-qualifications", permission: "quality.supplier.view" },
  { label: "Quality codes", to: "/app/masterdata/quality-codes", permission: "quality.config.view" },
  { label: "Sampling plans", to: "/app/masterdata/sampling-plans", permission: "quality.config.view" },
  { label: "Supplier document requirements", to: "/app/masterdata/document-requirements", permission: "quality.config.view" },
] });
